import React from "react";
import "../Footer/Footer.css";
import {
  FaPhoneAlt,
  FaFacebookF,
  FaInstagram,
  FaLinkedinIn,
} from "react-icons/fa";
import { Link } from "react-router-dom";
import Runner from "../Runner/Runner";
const Footer = () => {
  const calladmin = () => {
    window.location.href = "tel:02039449931";
  };
  const handleEmailClick = () => {
    window.location.href = "mailto:enquiries@journeyexperts.co.uk";
  };
  return (
    <footer className="footer">
      {/* Top Footer Section 
      <div className="top-footer">
        <div className="features">
          <p><span className="tick">✔</span> Best prices for flights, hotels & car</p>
          <p><span className="tick">✔</span> Experienced, friendly staff</p>
          <p><span className="tick">✔</span> Easy booking process</p>
        </div>
        <div className="logos">
          <img src="/protected.png" alt="Gold Trusted Service Award" />
          {/*-
          <img src="fl2.png" alt="British Travel Award" />
          <img src="fl3.png" alt="ATOL Protected" />
        
          <img src="fl4.png" alt="ABTA Travel with Confidence" />
           
        </div>
      </div>
      */}

      {/* Bottom Footer Section */}
      <div className="bottom-footer">
        {/* Contact Section */}
        <div className="logos">
          <img src="/protected.png" alt="Gold Trusted Service Award" />

          <Link to="/">
            <img src="/logo2.png" className="atol" alt="British Travel Award" />
          </Link>
          {/*-
          <img src="fl3.png" alt="ATOL Protected" />
        
          <img src="fl4.png" alt="ABTA Travel with Confidence" />
            -*/}
        </div>
        <div className="main-ad">
          <div className="main-l">
            {/* Links Section 1 */}
            <div className="links-section lip">
              <p className="newsletter-title">Our Pages</p>
              <Link className="flo" to="/">
                <p>Home</p>
              </Link>
              {/*-
              <Link className="flo" to="/airline">
                <p> Airlines</p>
              </Link>
              -*/}
              <Link className="flo" to="/destination">
                <p>Destinations</p>
              </Link>

              <Link className="flo" to="/business-flight">
                <p>Business Class Flight</p>
              </Link>
            </div>

            {/* Links Section 2 */}
            <div className="links-section lip2">
              <p className="newsletter-title">Our Links</p>

              <Link className="flo" to="/about-us">
                <p>About Us</p>
              </Link>

              <Link className="flo" to="/contact-us">
                <p>Contact Us</p>
              </Link>

              <Link className="flo" to="/privacy-policy">
                <p>Privacy Policy</p>
              </Link>
              <Link className="flo" to="/terms-and-conditions">
                <p>Terms & Conditions</p>
              </Link>
              {/*-
        <Link className="flo" to="/admin-login">
        <p>Admin Login</p>
        </Link>
        -*/}
              {/*-
       <h4 className="ot">Our Timings</h4>
       <h5 className="od">Monday - Friday</h5>
       <h3 className="ott">10:00 am to 07:00 pm</h3>
       <h5 className="od">Saturday - Sunday</h5>
       <h3 className="ott">10:00 am to 04:00 pm</h3>
       -*/}
            </div>
          </div>
          <div className="ad-c">
            <div className="ad-div">
              <p className="contact-titled">Address</p>
              <h5 className="odd">
                124 City Road, <br />
                London,EC1V 2NX
              </h5>
            </div>
            <div className="ad-div2">
              <p className="contact-titled">Cards Accepted</p>
              <img src="/visa.png" className="card-a" alt="visa-card" />
              <img src="/paypal.png" className="card-a" alt="paypal-card" />
              <img
                src="/american.png"
                className="card-a"
                alt="american-express"
              />
              <img src="/mastercard.png" className="card-a" alt="master-card" />
            </div>
          </div>
        </div>

        {/* Newsletter Section */}
        <div className="newsletter-section">
          <div className="contact-section">
            <p className="contact-title">Contact</p>

            <p className="f-c" onClick={calladmin}>
              <FaPhoneAlt className="phone-iconf" /> 02039449931
            </p>
            <p className="contact-em" onClick={handleEmailClick}>
              enquiries@journeyexperts.co.uk
            </p>
            {/*-
          <p>Mon-Fri: 9am–7pm</p>
          <p>Sat & Sun: 10am–4pm</p>
        

          <div className="social-icons">
            <FaFacebookF className="icon-f" />
            <FaInstagram className="icon-f"/>
            <FaLinkedinIn className="icon-f"/>
          </div>
            -*/}
          </div>
          <p className="newsletter-title">Sign up for exclusive offers</p>

          <div className="newsletter-input">
            <input type="email" placeholder="Your email address" />
            <button>Subscribe</button>
          </div>
        </div>
      </div>

      {/* Book with Confidence & Travel Aware Section */}
      <div className="info-section">
        {/*--
        
        <div className="book-confidence">
          <h3>Book with Confidence</h3>
          <p>Journey Experts are luxury holiday and business class flight specialists.</p>
          <p>We are a Member of ABTA which means you have the benefit of ABTA’s assistance and Code of Conduct. We provide financial protection for your money when you buy a package holiday. If you buy other travel arrangements such as accommodation only this protection doesn’t apply.</p>
          <p>Journey Experts Limited is an Accredited Body Member of Hays Travel Limited, ATOL 5534. Hays Travel Limited are registered in England and Wales with company number 1990682 and VAT number 193167195. Registered office: Gilbridge House, Keel Square, Sunderland SR1 3HA</p>
          <p>Registered office: Journey Experts Ltd, Cambridge House, 180 Upper Richmond Road, London, England, SW15 2SH.<br />
          Company Number: 087061860 / VAT Number: 17561434495</p>
        </div>

       
        <div className="travel-aware">
          <h3>Travel Aware</h3>
          <img src="/ta.png" alt="Travel Aware" />
          <p>The UK Government and the NHS have up-to-date advice on staying safe and healthy abroad. Find out more at <a href="https://travelaware.campaign.gov.uk/" target="_blank" rel="noopener noreferrer">https://travelaware.campaign.gov.uk/</a> & <a href="https://www.fitfortravel.nhs.uk" target="_blank" rel="noopener noreferrer">www.fitfortravel.nhs.uk</a></p>
          <p>For the latest travel advice from the Foreign & Commonwealth Office including security and local laws, plus passport and visa information, click <a href="https://www.gov.uk/foreign-travel-advice" target="_blank" rel="noopener noreferrer">here</a>.</p>
          <p>Keep informed of current travel health news by visiting <a href="https://travelhealthpro.org.uk/countries" target="_blank" rel="noopener noreferrer">this link</a>.</p>
        </div>
        --*/}
        <Runner />
      </div>
      <div className="disclaimer-section">
        <p>
          <strong>Journeyexperts.co.uk</strong> is a prominent travel brand
          operating under JOURNEY EXPERTS LTD, located at 124 City Road, London
          EC1V 2NX, England and Wales, with Company Registration No. 08596028,
          providing cheap flights, hotels and holidays .Many of the flights and
          flight-inclusive holidays through this website are financially
          protected by the ATOL scheme. But ATOL protection does not apply to
          all holiday and travel services listed on this website. Please ask us
          to confirm what protection may apply to your booking. If you do not
          receive an ATOL Certificate then the booking will not be ATOL
          protected. If you do receive an ATOL Certificate but all the parts of
          your trip are not listed on it, those parts will not be ATOL
          protected. If you have booked a flight only where the ticket is not
          issued immediately, your flight will be protected under our ATOL.
          Please see our booking conditions for information, or for more
          information about financial protection and the ATOL Certificate go to:{" "}
          <a
            href="https://www.journeyexperts.co.uk/ATOL-Certificate"
            className="link-fl"
            target="_blank"
            rel="noopener noreferrer"
          >
            https://www.journeyexperts.co.uk/ATOL-Certificate
          </a>{" "}
          Certificate. Journey Experts Ltd will only process & use data it
          captures for legitimate business reasons and will comply with its
          obligations under the Data Protection Act 1998 (“DPA”) and the General
          Data Protection Regulation 2016 (“GDPR”). Journey Experts Ltd Privacy
          Statement is available on our website. <strong>All fares are call only and subject to availability.</strong>
        </p>
      </div>

      {/* Bottom Bar */}
      <div className="bottom-bar">
        <p>
          <a
            className="link-fl"
            href="/privacy-policy"
            rel="noopener noreferrer"
          >
            Privacy Policy
          </a>{" "}
          |
          <a
            className="link-fl"
            href="/terms-and-conditions"
            rel="noopener noreferrer"
          >
            {" "}
            Terms & Conditions
          </a>{" "}
          | © {new Date().getFullYear()} Journey Experts. All rights reserved |
          Designed by{" "}
          <a
            className="link-fl"
            href="https://infogainsoft.com"
            target="_blank"
            rel="noopener noreferrer"
          >
            Infogainsoft
          </a>
        </p>
      </div>
    </footer>
  );
};

export default Footer;
